var path = 'app/scripts/modules/core/src/application/config/deleteApplicationSection.directive.html';
var html = "<p ng-if=\"!vm.hasServerGroups\">\n  Deleting the application only removes the associated metadata around the application.\n  It will <strong>not</strong> delete any security groups, load balancers, or pipeline configurations you\n  may have created.\n</p>\n\n<p ng-if=\"vm.hasServerGroups\">\n  You cannot delete this application because it has server groups.\n</p>\n<button class=\"btn btn-link\" ng-click=\"vm.deleteApplication()\" ng-if=\"!vm.hasServerGroups\"><span\n    class=\"glyphicon glyphicon-trash\"></span>\n  Delete Application\n</button>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/application/config/deleteApplicationSection.directive.html
// module id = 955
// module chunks = 0